/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import {
  byKeys,
  filterBy,
  findBy,
} from '@linc-technologies/linced-common/utils/arrays';
import {
  getCurrentMilestone,
  subjectProgressions,
} from '@linc-technologies/linced-common/utils/progressions';

export default class IndexController extends Controller {
  @service
  session;

  @service
  dates;

  @service
  heroApi;

  stickyPos = 301;

  @alias('model.person')
  person;

  @computed('person.{weeksAtSchool,monthsAtSchool,currentYearLevel}')
  get currentMilestone() {
    let milestones = this.get('model.milestones')
      .slice()
      .sort(
        (a, b) =>
          a.sequence - b.sequence ||
          (a.label || '').localeCompare(b.label || ''),
      );

    return getCurrentMilestone(
      milestones,
      this.person,
      this.dates.rolloverMonthDate,
    );
  }

  @computed('model.expectations.[]', 'currentMilestone')
  get expectations() {
    return this.get('model.expectations').filter(
      (item) => item.milestone.id === this.get('currentMilestone.id'),
    );
  }

  @computed('model.progressions.[]', 'currentMilestone')
  get progressions() {
    return this.get('model.progressions').filter(
      (item) => item.milestone.id === this.get('currentMilestone.id'),
    );
  }

  @computed('expectations.[]')
  get data() {
    let expectations = this.expectations;
    let progressions = this.progressions;
    let subjects = this.get('model.subjects');
    let levels = this.get('model.levels');
    let schoolId = this.get('session.activeSchool');
    let data = [];

    subjects.forEach((subject) => {
      let expectation = findBy(expectations, 'goalSubject.id', subject.id);
      let progression = findBy(progressions, 'goalSubject.id', subject.id);
      let subjectLevels = filterBy(levels, 'goalSubject.id', subject.id).sort(
        byKeys('sequence', 'label'),
      );

      let subjectData = subjectProgressions(
        subject,
        subjectLevels,
        expectation,
        progression,
      );
      if (!isEmpty(subjectData)) {
        this.heroApi.goals
          .getLearnerSummary(schoolId, this.person.id, subject.id)
          .then((learnerSummary) => {
            if (!isEmpty(learnerSummary)) {
              subjectData.set('summary', learnerSummary);
            }
          });
        data.push(subjectData);
      }
    });

    return data;
  }
}
